import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "新しいパスワード",
    keyword: "password",
    type: "label",
    typeForLabelText: "password",
    requiredIcon: true,
    inputProps: { minLength: 10, maxLength: 24 },
  },
  {
    title: "新しいパスワード再入力",
    keyword: "passwordConfirm",
    type: "label",
    typeForLabelText: "password",
    requiredIcon: true,
    inputProps: { minLength: 10, maxLength: 24 },
  },
  {
    title: "パスワードを表示する",
    keyword: "showPassword",
    type: "node",
    node: <></>,
  },
];
const schema = {
  password: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[!-~]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0056E"),
    },
    minLength: {
      value: 10,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "10"),
    },
    maxLength: {
      value: 24,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "24"),
    },
  },
  passwordConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[!-~]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0056E"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
    validate: (value: any, formValues: any) => {
      if (formValues.password !== formValues.passwordConfirm) {
        return TkPropertyMessageGet("TKMSG_SCR0078E");
      }
    },
  },
};
export { schema, fakeTableList };
